// extracted by mini-css-extract-plugin
export default {"rowContainer":"styles_rowContainer__CKeHs","wrapper":"styles_wrapper__gxorF","key":"styles_key__2jSvp","value":"styles_value__NPlRR","icon":"styles_icon__wVf+p"};